import ClientLayout from '@/Layouts/Client';
import { hasLocalCompany} from "@/services/company";
import Popper from 'vue3-popper';
import ImageCropper from '@/components/ImageCropper';
import ImageUpload from '@/components/client/ImageUpload';
import ClientModal from '@/components/client/Modal';
import { toDataUrl } from '@/Util/misc';
import { createToast } from 'mosha-vue-toastify';
import PagePreview from '@/Pages/Client/Page/PagePreview';
import { step } from '@/Layouts/ClientUtils';
import SidebarPopup from '@/components/client/SidebarPopup';
import PrimaryButton from '@/components/client/Buttons/PrimaryButton';
import SecondaryButton from '@/components/client/Buttons/SecondaryButton';
import InputField from '@/components/client/Inputs/Input';
import HtmlEditorField from '@/components/client/Inputs/HtmlEditorInput';
import { directive } from 'vue-tippy';

export default {
    props: ['images', 'company', 'companyCities', 'initialCampaigns'],
    inject: ['$isMobile'],
    layout: ClientLayout,
    components: {
        ImageUpload, Popper, ImageCropper, ClientModal, PagePreview, SidebarPopup, PrimaryButton, SecondaryButton, InputField, HtmlEditorField
    },
    directives: {
        tippy: directive,
    },
    data() {
        return {
            step: step,
            isSaving: false,
            companyInfoSyncHasBeenOffered: false,
            isShowingCompanyLogoCropper: false,
            isShowingCompanyLogoMethodModal: false,
            isShowingCompanyFirstImageCropper: false,
            isShowingCompanySecondImageCropper: false,
            isShowingPreviewModal: false,
            isShowingEditingCompanyInfoModal: false,
            isShowingEditingCompanyContactModal: false,
            isShowingStopSyncingAlertModal: false,
            isShowingSaveOptionsModal: false,
            isShowingFirstImageInfoModal: false,
            isShowingSecondImageInfoModal: false,
            previewData: {},
            isShowingSidebarPopup: false,
            toShowAfterSyncAlertProceed: null,
            editingCity: 'default',
            renderTippys: false,
            imageHandlers: {
                logoImage: {
                    showingCropper: false,
                    cropperRef: 'companyLogoCropper',
                    uploadRef: 'cropperCompanyLogoUpload',
                    formKey: 'company_logo',
                },

                firstImage: {
                    showingCropper: false,
                    cropperRef: 'companyFirstImageCropper',
                    uploadRef: 'companyFirstImageUpload',
                    formKey: 'company_first_image',
                },

                secondImage: {
                    showingCropper: false,
                    cropperRef: 'companySecondImageCropper',
                    uploadRef: 'companySecondImageUpload',
                    formKey: 'company_second_image',
                }
            },
            form: this.$inertia.form({
                publish: false,
                default: {
                    company_logo: { image: null, image_crop: null, file: null, tmp_file: null, cropper: null, tmp_cropper: null, deleted: false, },
                    company_first_image: { image: null, image_crop: null, file: null, tmp_file: null, cropper: null, tmp_cropper: null, deleted: false, },
                    company_second_image: { image: null, image_crop: null, file: null, tmp_file: null, cropper: null, tmp_cropper: null, deleted: false, },
                    info: null,
                    heading: null,
                    public_url: null,
                    public_phone_number: null,
                    public_email_address: null,
                    public_street_address: null,
                    public_zip_code: null,
                    public_city: null,
                    fb_url: null,
                    ig_url: null,
                }
            }),
        }
    },
    watch: {
        'form.default': {
            deep: true,
            handler(newValue, oldValue) {
                this.syncCompanyCitysInfo();
            }
        }
    },
    mounted() {
        if (!this.hasVisitedSidebarPopup()) {
            this.isShowingSidebarPopup = true;
        }

        step.name = 'page';

        if (this.images.company_first_image.image) {
            this.form.default.company_first_image.image = this.images.company_first_image.image;
            this.form.default.company_first_image.image_crop = this.images.company_first_image.image_crop;
        }

        if (this.images.company_second_image.image) {
            this.form.default.company_second_image.image = this.images.company_second_image.image;
            this.form.default.company_second_image.image_crop = this.images.company_second_image.image_crop;
        }

        if (this.images.company_logo_image.image) {
            this.form.default.company_logo.image = this.images.company_logo_image.image;
            this.form.default.company_logo.image_crop = this.images.company_logo_image.image_crop;
            this.form.default.company_logo.cropper = this.images.company_logo_image.cropper;
        }

        this.form.default.heading = this.company.heading;
        this.form.default.info = this.company.info;
        this.form.default.public_url = this.company.public_url;
        this.form.default.public_email_address = this.company.public_email_address;
        this.form.default.public_street_address = this.company.public_street_address;
        this.form.default.public_phone_number = this.company.public_phone_number;
        this.form.default.public_zip_code = this.company.public_zip_code;
        this.form.default.public_city = this.company.public_city;
        this.form.default.fb_url = this.company.fb_url;
        this.form.default.ig_url = this.company.ig_url;

        this.companyCities.forEach((companyCity) => {
            const fields = this.fieldsToSync();

            this.form[companyCity.city.slug] = {
                sync_from_main_enabled: companyCity.sync_from_main_enabled
            };

            for (var i = 0; i < fields.length; i++) {
                this.form[companyCity.city.slug][fields[i]] = companyCity[fields[i]];
            }
        });
    },
    created () {
        setTimeout(() => {
            this.renderTippys = true;
        }, 250);
    },
    methods: {
        proceedSyncAlert() {
            this.isShowingStopSyncingAlertModal = false;
            this[this.toShowAfterSyncAlertProceed] = true;
            this.form[this.editingCity].sync_from_main_enabled = false;
        },

        currentEditingCity() {
            return this.companyCities.find(c => c.city.slug === this.editingCity);
        },

        cancelSyncAlert() {
            this.isShowingStopSyncingAlertModal = false;
            setTimeout(() => this.editingCity = 'default', 300);
        },

        startEditCompanyInfo() {
            if (this.editingCity !== 'default' && this.form[this.editingCity].sync_from_main_enabled === true) {
                this.isShowingStopSyncingAlertModal = true;
                this.toShowAfterSyncAlertProceed = 'isShowingEditingCompanyInfoModal';
            } else {
                this.isShowingEditingCompanyInfoModal = true
            }
        },

        startEditCompanyContact() {
            if (this.editingCity !== 'default' && this.form[this.editingCity].sync_from_main_enabled === true) {
                this.isShowingStopSyncingAlertModal = true;
                this.toShowAfterSyncAlertProceed = 'isShowingEditingCompanyContactModal';
            } else {
                this.isShowingEditingCompanyContactModal = true
            }
        },

        syncCompanyCitysInfo() {
            const companyCities = this.companyCities.filter((c) => c.sync_from_main_enabled === true);

            const fields = this.fieldsToSync();

            companyCities.forEach((companyCity) => {
                if (this.form[companyCity.city.slug].sync_from_main_enabled === false) {
                    return;
                }

                for (var i = 0; i < fields.length; i++) {
                    this.form[companyCity.city.slug][fields[i]] = this.form.default[fields[i]]
                }
            });
        },

        fieldsToSync() {
            return ['info', 'heading', 'public_url', 'public_phone_number', 'public_email_address', 'public_street_address', 'public_zip_code', 'public_city', 'fb_url', 'ig_url'];
        },

        startPublish() {
            if (this.step.isCompleted()) {
                return;
            }

            if (!confirm('Är du säker på att du vill publicera företagssidan? Den kommer då gå live på familjekortet.se.')) {
                return;
            }

            this.isShowingSaveOptionsModal = false;
            this.form.publish = true;

            this.save();
        },

        startSave() {
            this.isShowingSaveOptionsModal = false;

            this.save();
        },

        startCompanyLogoImageUploading() {
            this.isShowingCompanyLogoMethodModal = false;

            setTimeout(() => this.startCropperFileInputDialog('logoImage'), 300);
        },

        hasVisitedSidebarPopup() {
            return window.localStorage.getItem('fk_client:page_sidebar_popup_visited');
        },

        closeSidebarPopup() {
            window.localStorage.setItem('fk_client:page_sidebar_popup_visited', true);
            this.isShowingSidebarPopup = false;
        },

        startImageUpload(imageType) {
            const imageHandler = this.imageHandlers[imageType];
            this.$refs[imageHandler.uploadRef].triggerFileInputDialog()
        },

        imageUploaded(imageType, image, file) {
            const imageHandler = this.imageHandlers[imageType];
            this.initCropper(imageHandler.cropperRef, image);
            this.form['default'][imageHandler.formKey].tmp_file = file;
        },

        cropperChanged(imageType, value) {
            const imageHandler = this.imageHandlers[imageType];
            this.form['default'][imageHandler.formKey].tmp_cropper = value
        },

        async onCrop(imageType, canvas) {
            if (!canvas) return;

            const imageHandler = this.imageHandlers[imageType];

            this.form['default'][imageHandler.formKey].image_crop = canvas.toDataURL();

            if (this.form['default'][imageHandler.formKey].tmp_file instanceof File) {
                this.form['default'][imageHandler.formKey].image = await this.readImage(this.form['default'][imageHandler.formKey].tmp_file);
                this.form['default'][imageHandler.formKey].file = this.form['default'][imageHandler.formKey].tmp_file;
                this.form['default'][imageHandler.formKey].tmp_file = null;
            }

            this.form['default'][imageHandler.formKey].cropper = this.form['default'][imageHandler.formKey].tmp_cropper;
            this.form['default'][imageHandler.formKey].tmp_cropper = null;
            this.isShowingCompanyFirstImageCropper = false;
        },

        performCrop(imageType) {
            const imageHandler = this.imageHandlers[imageType];
            this.$refs[imageHandler.cropperRef].crop();
            this.closeCropper(imageType);
        },

        startCropperFileInputDialog(imageType) {
            const imageHandler = this.imageHandlers[imageType];
            imageHandler.showingCropper = true;
            setTimeout(() => this.$refs[imageHandler.uploadRef].triggerFileInputDialog(), 300);
        },

        startCropperWithCurrentImage(imageType) {
            const imageHandler = this.imageHandlers[imageType];
            imageHandler.showingCropper = true;
            setTimeout(() => this.initCropper(imageHandler.cropperRef, this.form.default[imageHandler.formKey].image), 300);
        },

        closeCropper(imageType) {
            const imageHandler = this.imageHandlers[imageType];
            imageHandler.showingCropper = false;
            this.$refs[imageHandler.cropperRef].destroy()
        },

        isShowingCropper(imageType) {
            return this.imageHandlers[imageType].showingCropper;
        },

        markImageAsDeleted(imageType) {
            const confirmation = confirm('Är du säker på att du vill ta bort denna bild?');

            if (!confirmation) return;

            const imageHandler = this.imageHandlers[imageType];

            this.form.default[imageHandler.formKey].image = null;
            this.form.default[imageHandler.formKey].image_crop = null;
            this.form.default[imageHandler.formKey].file = null;
            this.form.default[imageHandler.formKey].tmp_file = null;
            this.form.default[imageHandler.formKey].cropper = null;
            this.form.default[imageHandler.formKey].deleted = true;

            if (imageHandler.onDelete) {
                imageHandler.onDelete();
            }
        },

        readImage(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onerror = () => {
                    reader.abort();
                    reject(new DOMException('Problem parsing input file.'));
                };

                reader.onload = () => {
                    resolve(reader.result);
                };

                reader.readAsDataURL(file);
            });
        },

        startPreview() {
            this.previewData = {
                logo_image: this.form['default'].company_logo.image_crop,
                first_image: this.form['default'].company_first_image.image_crop,
                second_image: this.form['default'].company_second_image.image_crop,

                heading: this.form[this.editingCity].heading,
                info: this.form[this.editingCity].info,
                public_url: this.form[this.editingCity].public_url,
                public_email_address: this.form[this.editingCity].public_email_address,
                public_street_address: this.form[this.editingCity].public_street_address,
                public_phone_number: this.form[this.editingCity].public_phone_number,
                public_zip_code: this.form[this.editingCity].public_zip_code,
                public_city: this.form[this.editingCity].public_city,
                fb_url: this.form[this.editingCity].fb_url,
                ig_url: this.form[this.editingCity].ig_url,
            };

            this.isShowingPreviewModal = true;

            setTimeout(() => this.$refs.pagePreview.createPreview(), 300);
        },

        showCurrentLogoCropper() {
            this.isShowingCompanyLogoMethodModal = false;

            setTimeout(() => {
                this.startCropperWithCurrentImage('logoImage');
            }, 300);
        },

        showCompanyLogoCropper(image, file) {
            this.isShowingCompanyLogoMethodModal = false
            this.imageHandlers['logoImage'].showingCropper = true;

            setTimeout(() => {
                 this.imageUploaded('logoImage', image, file)
            }, 300);
        },

        initCropper(ref, image, options = { locked: false, cropper: {} }) {
            this.$refs[ref].replace(image);

            if (options.locked) {
                this.$refs[ref].lock();
            }

            this.$refs[ref].setData(options.cropper);
        },

         companyLogoUploadedDirectly(image, file) {
            this.isShowingCompanyLogoMethodModal = false;
            this.form.default.company_logo.image = image;
            this.form.default.company_logo.image_crop = image;
            this.form.default.company_logo.file = file;
            this.form.default.company_logo.cropper = null;
        },

        getCompany() {
            axios.get('/api/client/company').then(response => {
                this.company = response.data.data;

                this.form.heading = this.company.heading;
                this.form.info = this.company.info;
                this.form.public_url = this.company.public_url;
                this.form.public_phone_number = this.company.public_phone_number;
                this.form.public_email_address = this.company.public_email_address;
                this.form.public_street_address = this.company.public_street_address;
                this.form.public_zip_code = this.company.public_zip_code;
                this.form.public_city = this.company.public_city;
                this.form.fb_url = this.company.fb_url;
                this.form.ig_url = this.company.ig_url;

                this.imageInfo.company_id = this.company.id;

                this.companyImages = {};
            });
        },

        async save() {
            const success = await this.savePage().catch(() => {
                let actionTaken = false;
                const errors = this.form.errors;

                if ((errors.heading || errors.info) && !actionTaken) {
                    actionTaken = true;
                    this.isShowingEditingCompanyInfoModal = true;
                }

                const hasContactError = errors.public_email_address;

                if (hasContactError && !actionTaken) {
                    this.isShowingEditingCompanyContactModal = true;
                }
            });

            if (!this.step.isCompleted() && this.form.publish && success) {
                this.step.complete();
            }
        },

        async savePage() {
            if (this.isSaving) {
                return;
            }

            this.isSaving = true;

            const formData = {
                publish: this.form.publish,

                company_second_image: {
                    file: this.form['default'].company_second_image.file,
                    cropper: this.form['default'].company_second_image.cropper,
                    deleted: this.form['default'].company_second_image.deleted,
                },

                company_first_image: {
                    file: this.form['default'].company_first_image.file,
                    cropper: this.form['default'].company_first_image.cropper,
                    deleted: this.form['default'].company_first_image.deleted,
                },

                company_logo_image: {
                    file: this.form['default'].company_logo.file,
                    cropper: this.form['default'].company_logo.cropper,
                    deleted: this.form['default'].company_logo.deleted,
                },

                heading: this.form['default'].heading,
                info: this.form['default'].info,
                public_url: this.form['default'].public_url,
                public_phone_number: this.form['default'].public_phone_number,
                public_email_address: this.form['default'].public_email_address,
                public_street_address: this.form['default'].public_street_address,
                public_zip_code: this.form['default'].public_zip_code,
                public_city: this.form['default'].public_city,
                fb_url: this.form['default'].fb_url,
                ig_url: this.form['default'].ig_url,
            };

            this.companyCities.map((c) => c.city.slug).forEach((citySlug) => {
                formData[citySlug] = this.form[citySlug];
            });

            return new Promise((resolve, reject) => {
                this.form.transform((data) => formData).post(`/kund/${this.company.slug}/foretags-sida`, {
                    onSuccess: () => {
                        if (this.step.isCompleted() || !this.form.publish) {
                            this.isSaving = false;
                        }

                        createToast('Dina ändringar har sparats!', {
                            type: 'success',
                            timeout: 2000,
                        });

                        resolve(true);
                    },

                    onError: () => {
                        this.isSaving = false;
                        reject(false);
                    }
                });
            });
        },
        hasLocal() {
            return hasLocalCompany(this.company);
        }
    }
}
